import { createSvgIcon } from "@mui/material";

export default createSvgIcon(
  <svg
    width="19"
    height="19"
    viewBox="0 0 19 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      id="Vector"
      d="M16.7 0.5H2.3C1.31 0.5 0.5 1.31 0.5 2.3V18.5L4.1 14.9H16.7C17.69 14.9 18.5 14.09 18.5 13.1V2.3C18.5 1.31 17.69 0.5 16.7 0.5ZM16.7 13.1H3.38L2.3 14.18V2.3H16.7V13.1Z"
      fill="#222A5C"
    />
  </svg>,
  "Thread"
);
